import { ConfirmFinancesController } from './confirmFinances.controller';
import template from './confirmFinances.html';

export const confirmFinancesComponent = {
  name: 'confirmFinances',
  restrict: 'E',
  template,
  controller: ConfirmFinancesController,
  controllerAs: 'vm',
  bindings: {
    finances: '<?',
    ticket: '<',
    pdfUrl: '<',
    onSubmit: '&',
    onBack: '&',
    showBack: '<',
    editable: '<',
    optIn: '<',
    split: '@',
    translatePrefix: '@'
  }
};
